<template>
    <div>
        <CFTitle title="6. Localizare proiect"></CFTitle>
        <M3Warn type="yellow-warn" text="Locațiile pot fi modificate din pagina "><template v-slot:link><router-link to="/aplicatii/m3-sketch/proiectul-meu" style="margin-left: 10px; color: #ffffff; font-weight: 600">Proiectul meu</router-link></template></M3Warn>
        <div class="mt-5 mb-5">
            <validation-observer #default="{ invalid }" ref="localizareProiect">
                <span class="display-none">{{ invalid }}</span>
                <div v-for="(locatie, key) in form.locations" :key="key" class="flex justify-content-center mb-1 position-relative">
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 20%;"
                        class="w-100"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Localitate"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="locatie.city"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 20%;"
                        class="w-100"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Județ"
                            class="has-icon custom-responsive"
                        >
                            <b-form-select
                                v-model="locatie.state"
                                :options="states"
                                text-field="stateName"
                                value-field="stateCode"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                                :class="completed ?'disabled-select':''"
                                @change="pickRegion(key)"
                            >
                            </b-form-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 20%;"
                        class="w-100"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Regiune"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="locatie.region"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                readonly
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 36%;"
                        class="w-100"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Informații proiect"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="locatie.project_info"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <!--                    <b-icon-x-circle-fill v-if="key > 0" class="delete-icon" @click="deleteLocation(key)"></b-icon-x-circle-fill>-->
                </div>
            </validation-observer>
            <!--            <a class="add-button mb-3" style="float: right" @click="addLocation()">-->
            <!--                <p class="mr-3">Adaugă locație implementare</p>-->
            <!--                <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>-->
            <!--            </a>-->
        </div>

        <!--        <hr class="mt-5">-->
        <!--        <div>-->
        <!--            <b-form-checkbox-->
        <!--                v-model="completed"-->
        <!--                switch-->
        <!--                size="lg"-->
        <!--                class="switch-box"-->
        <!--                style="margin-top: 0"-->
        <!--            >Informațiile sunt complete și corecte</b-form-checkbox>-->
        <!--        </div>-->
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BFormInput, BFormGroup, BFormCheckbox, BIconInfoCircleFill, BTooltip, BIconPlusCircleFill, BIconXCircleFill, BFormSelect } from "bootstrap-vue";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn';
    import CFTextarea from "./CFTextarea";
    // import _ from "lodash";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    require('@/helpers/validations/validations');
    export default {
        components: {
            CFTitle,
            CFTextarea,
            M3Warn,
            BFormInput, BFormGroup, BFormCheckbox, BIconInfoCircleFill, BTooltip, BIconPlusCircleFill, BIconXCircleFill, BFormSelect,
            ValidationProvider, ValidationObserver
        },
        props: {
            data: null,
            states: null,
            m3GrantApplication: null,

        },
        data() {
            return {
                completed: true,
                form: {
                    locations: [
                        {
                            city: '',
                            state: '',
                            region: '',
                            project_info: 'Investiții în activități productive pentru '+JSON.parse(localStorage.getItem('currentM3Company')).name,
                        }
                    ]
                }
            }
        },
        watch: {
            data: {
                handler: function() {
                    this.getFormData()
                },
                deep: true
            },
        },
        mounted() {
            this.getFormData()
            this.$store.dispatch('finantare/addToProgress', 'Localizare proiect')
        },
        methods: {
            getFormData() {
                // if(this.m3GrantApplication && this.m3GrantApplication.localizare_proiect){
                //     this.form = this.m3GrantApplication.localizare_proiect
                // } else{
                if(this.data && this.data.m3_project && this.data.m3_project.location_address && this.data.m3_project.location_address.length > 0){
                    this.form.locations = []
                    this.data.m3_project.location_address.forEach(location => {
                        this.form.locations.push({city: location.city, state: location.state, region: location.region, project_info: (this.data.m3_project.mysmis && this.data.m3_project.mysmis.title) ? location.city + ', ' + location.address+ ' ( ' +this.data.m3_project.mysmis.title + ' )' : 'Investiții în activități productive pentru '+JSON.parse(localStorage.getItem('currentM3Company')).name,})
                    })
                    axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {localizare_proiect: this.form})
                }
                // }
            },
            // addLocation() {
            //     if(this.completed){
            //         this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
            //     } else {
            //         this.form.locations.push({
            //             city: '',
            //             state: '',
            //             region: '',
            //             project_info: (this.data.m3_project.mysmis && this.data.m3_project.mysmis.title) ? this.data.m3_project.mysmis.title : '',
            //         })
            //     }
            //
            // },
            // deleteLocation(key){
            //     if(this.completed){
            //         this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
            //     } else {
            //         this.form.locations.splice(key, 1)
            //     }
            //
            // },
            // sendForm() {
            // this.$refs.localizareProiect.validate().then((e) => {
            //     if (!e) {
            //         this.completed = false
            //         this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
            //     } else {
            //         if(this.completed){
            //             axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {localizare_proiect: this.form})
            //                 .then( () => {
            //                     this.$toast.success('Informațiile au fost salvate!')
            //                     this.$emit('savedData')
            //                     this.$store.dispatch('finantare/addToProgress', 'Localizare proiect')
            //                 })
            //         }
            //         else{
            //             this.$store.dispatch('finantare/removeFromProgress', 'Localizare proiect')
            //         }
            //     }
            // })
            // },
            // pickRegion(key) {
            //     this.form.locations[key].region = _.filter(this.states, v => v.stateCode === this.form.locations[key].state)[0].regionName
            // }
        }
    }
</script>

<style scoped>
.add-button{
    max-width: 255px !important;
}
.delete-icon{
    position: absolute;
    top: 9px;
    left: -5px;
    color: var(--dangerColor);
    cursor: pointer;
}
.custom-select{
    color: #767a95;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 2px;
    max-height: 33px;
    margin: 0 !important;
    font-weight: 600;
    background: #e9ecef url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
}
.disabled-select{
    background: #a1fff1 url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
    pointer-events: none;
}
@media screen and (max-width: 1441px) {
    .justify-content-center.mb-1.position-relative {
        flex-direction: column;
    }
}
</style>
